<template>
  <div>
    <el-select v-model="value" :placeholder="placeholder" clearable @change="onChange">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectInput',
  model: {
    prop: 'val',
    event: 'modify'
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    val: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    val() {
      if (this.val) {
        this.value = this.val
      }
    }
  },

  created() {
    if (this.val) {
      this.value = this.val
    }
  },
  methods: {
    onChange() {
      this.$emit('modify', this.value)
    }
  }
}
</script>

<style scoped>

</style>
